module.exports = __webpack_public_path__ + "static/media/environmental-book.e2809796.JPG";